<template>
  <div>
    <h1>Our flavours</h1>
    <div class="sm:flex justify-between align-start flex-wrap">
      <div v-for="item in flavours" :key="item.id" class="sm:w-1/2 mb-8">
        <div class="sm:mx-2">
          <framed-image :images="[item.image]" v-if="item.image" :width="500" :height="333" />
          <div class="mx-2 sm:mx-0">
            <h2 class="mb-1">{{item.name}}</h2><p class="text-sm text-gray-600">{{item.description}}</p>
          </div>
        </div>
      </div>
    </div>

    <router-link class="border border-jpink block py-2 px-4 mx-2 text-jpink hover:bg-jpink hover:text-white" :to="{name: 'basket'}">Order now</router-link>

  </div>
</template>

<script>
import FramedImage from '../components/FramedImage'
import { filter } from 'lodash'
export default {
  computed: {
    flavours() {
      return filter(this.$root.$data.flavours, o => o.image)
    }
  },
  components: {
    FramedImage
  },
  head: {
    title() {
      return {
        inner: "Flavours"
      }
    }
  }
}
</script>

<style>

</style>